import "./LocalSeoConsultantSwansea.module.css";
import Header from "@/reusable_sections/Header";
import Services from "./sections/Services";
import Servicegridlisting from "./sections/Servicegridlisting";
import Editorial from "./sections/Editorial";
import Consultation from "./sections/Consultation";
import MethodologyFlow from "./sections/MethodologyFlow";
import CaseStudyImpact from "./sections/CaseStudyImpact";
import Localseofaq from "./sections/Localseofaq";
import Localseo from "./sections/Localseo";
import ConsultantBenefits from "./sections/ConsultantBenefits";
import Swanseamarket from "./sections/Swanseamarket";
import Footer from "@/reusable_sections/Footer";
export default function LocalSeoConsultantSwanseaPage() {
  return <div>
      <Header />
      <Services />
      <Servicegridlisting />
      <Editorial />
      <Consultation />
      <MethodologyFlow />
      <CaseStudyImpact />
      <Localseofaq />
      <Localseo />
      <ConsultantBenefits />
      <Swanseamarket />
      <Footer />
    </div>;
}